import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import StatCard from '../../components/StatCard';
import ExportButton from '../../components/ExportButton';
import { getInventoryReport } from '../../utils/queries';

export default function InventoryReport() {
	const { activeStoreId } = useContext(MyContext);
	const [threshold, setThreshold] = useState(5);
	const [report, setReport] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		getInventoryReport({ storeId: activeStoreId || undefined, threshold }).then((result) => {
			if (result?.success) setReport(result.data);
			setLoading(false);
		});
	}, [activeStoreId, threshold]);

	const columns = [
		{ key: 'product_name', header: 'Product' },
		{ key: 'erp_product_number', header: 'PACE #' },
		{ key: 'location', header: 'Location' },
		{ key: 'quantity_available', header: 'Available' },
		{ key: 'quantity_on_hand', header: 'On Hand' },
	];

	return (
		<div className='py-8 pr-8'>
			<div className='flex items-center justify-between mb-6'>
				<h1 className='text-2xl font-light tracking-tight'>Inventory Report</h1>
				<ExportButton
					fileName='inventory-report'
					sections={[
						{
							data: report?.rows || [],
							columns: columns.map((c) => c.header),
							columnKeys: columns.map((c) => c.key),
							columnTypes: ['text', 'text', 'text', 'number', 'number'],
						},
					]}
				/>
			</div>

			<div className='mb-6 flex flex-col w-32'>
				<label>Low-stock threshold</label>
				<input
					type='number'
					className='form-input'
					value={threshold}
					onChange={(e) => setThreshold(Number(e.target.value))}
				/>
			</div>

			{loading || !report ? (
				<div className='text-sm text-gray-400'>Loading...</div>
			) : (
				<>
					<div className='grid grid-cols-4 gap-4 mb-8'>
						<StatCard label='Low Stock Items' value={report.summary.total_low_stock} />
						<StatCard label='Out of Stock Items' value={report.summary.total_out_of_stock} />
					</div>

					<DataTable columns={columns} data={report.rows} emptyHeading='No low-stock items' />
				</>
			)}
		</div>
	);
}
